// src/components/GoogleLogin.js
import { useEffect } from "react";

export const GoogleLogin = ({ onSuccess }) => {
  useEffect(() => {
    // Load Google Sign-In script
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    script.onload = () => {
      window.google.accounts.id.initialize({
        client_id:
          "1082096662546-ce9ufdk3r1a0dt04rn4g8qq45lg8p3cq.apps.googleusercontent.com",
        callback: onSuccess,
      });

      window.google.accounts.id.renderButton(
        document.getElementById("googleButton"),
        {
          theme: "filled_blue",
          size: "large",
          width: "100%",
          text: "continue_with",
        }
      );
    };

    return () => {
      // Cleanup
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, [onSuccess]);

  return (
    <div className="mt-6">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-2 bg-white text-gray-500">Or continue with</span>
        </div>
      </div>
      <div className="mt-6">
        <div id="googleButton" className="w-full flex justify-center"></div>
      </div>
    </div>
  );
};
